import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Brain, Settings, Bell, Search, LogOut
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import ChatBot from '../components/ChatBot';

const TrainingDashboardPage = () => {
  const [showChatbot, setShowChatbot] = useState(false);
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-background border-b border-border sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <Brain className="h-8 w-8 text-accent" />
                <span className="ml-2 text-xl font-bold text-foreground">
                  Training Portal
                </span>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search..."
                  className="pl-10 pr-4 py-2 border border-border rounded-lg bg-secondary/30 text-foreground focus:outline-none focus:ring-2 focus:ring-accent"
                />
                <Search className="absolute left-3 top-2.5 h-5 w-5 text-foreground/50" />
              </div>
              <button className="text-foreground/70 hover:text-foreground relative">
                <Bell className="h-5 w-5" />
                <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500"></span>
              </button>
              <button className="text-foreground/70 hover:text-foreground">
                <Settings className="h-5 w-5" />
              </button>
              <div className="border-l border-border h-6"></div>
              <div className="flex items-center">
                <div className="h-8 w-8 rounded-full bg-accent/10 flex items-center justify-center text-accent font-medium">
                  {user?.user_metadata?.name?.[0] || 'U'}
                </div>
                <button 
                  onClick={handleSignOut}
                  className="ml-4 text-foreground/70 hover:text-foreground"
                >
                  <LogOut className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Welcome Section */}
        <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg p-6 text-white shadow-lg mb-6">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold">¡Bienvenido, {user?.user_metadata?.name || 'Usuario'}!</h2>
              <p className="mt-1 text-white/90">
                Continúa tu viaje como Azure Administrator
              </p>
            </div>
            <button
              onClick={() => setShowChatbot(true)}
              className="bg-white text-purple-600 px-4 py-2 rounded-lg hover:bg-white/90 transition-colors flex items-center shadow-md hover:shadow-lg"
            >
              <Brain className="h-4 w-4 mr-2" />
              Ask AI Mentor
            </button>
          </div>
        </div>
      </div>

      {/* Chatbot */}
      {showChatbot && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="w-full max-w-2xl">
            <ChatBot 
              role="azure-admin"
              onClose={() => setShowChatbot(false)} 
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainingDashboardPage;